export function emojiForProduct(name: string | undefined): string {
  const n = (name ?? '').toLowerCase()
  if (n.includes('dragon')) return '🐉'
  if (n.includes('sonic')) return '🦔'
  if (n.includes('sylvester') || n.includes('cat')) return '🐈‍⬛'
  if (n.includes('luffy') || n.includes('monkey')) return '🐒'
  if (n.includes('courage') || n.includes('dog')) return '🐕'
  if (
    n.includes('nike') || n.includes('shoe') || n.includes('sandal') ||
    n.includes('slide') || n.includes('crocs') || n.includes('yeezy') ||
    n.includes('jordan') || n.includes('air force')
  ) return '👟'
  if (n.includes('keychain')) return '🔑'
  if (n.includes('skeleton') || n.includes('skull')) return '💀'
  if (
    n.includes('stanley') || n.includes('tumbler') ||
    n.includes('cup') || n.includes('owala')
  ) return '🥤'
  if (n.includes('drawer') || n.includes('organizer')) return '🗄️'
  if (n.includes('flexi') || n.includes('rock')) return '🪨'
  return '📦'
}

export function colorPairForProduct(name: string): [string, string] {
  // Stable hash so the same name always gets the same gradient.
  let h = 0
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0
  const palette: Array<[string, string]> = [
    ['#3b82f6', '#1d4ed8'], // blue
    ['#10b981', '#059669'], // green
    ['#ef4444', '#dc2626'], // red
    ['#f59e0b', '#d97706'], // amber
    ['#a855f7', '#7e22ce'], // purple
    ['#06b6d4', '#0e7490'], // cyan
    ['#ec4899', '#be185d'], // pink
    ['#84cc16', '#4d7c0f'], // lime
  ]
  return palette[h % palette.length]
}

export function formatMoney(amount: number): string {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  })
  if (amount < 0) {
    return '-' + formatter.format(Math.abs(amount))
  }
  return formatter.format(amount)
}

export function formatDate(input: Date | string): string {
  const d = typeof input === 'string' ? new Date(input + 'T00:00:00') : input
  const m = d.getMonth() + 1
  const day = d.getDate()
  const year = String(d.getFullYear()).slice(-2)
  return `${m}/${day}/${year}`
}

export function monthKey(input: Date | string): string {
  const d = typeof input === 'string' ? new Date(input + 'T00:00:00') : input
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  return `${y}-${m}`
}
